import { render, staticRenderFns } from "./InkasJou.vue?vue&type=template&id=78244218&scoped=true&"
import script from "./InkasJou.vue?vue&type=script&lang=js&"
export * from "./InkasJou.vue?vue&type=script&lang=js&"
import style0 from "./InkasJou.vue?vue&type=style&index=0&id=78244218&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78244218",
  null
  
)

export default component.exports